import React from 'react'
import { useStyles } from './ButtonName.styles'
import clsx from 'clsx'
import { useStyles as commonStyles } from '../../FlyOutStorefront.styles'
import { Typography } from '@mui/material'
import { TextInputV2 } from '@labrav/react-components'
import { useFormikContext } from 'formik'
import { ButtonInCreation } from '../../../../modules/storefront/buttonCreation/reducer'

export const ButtonName: React.FC = () => {
  const { classes } = useStyles()
  const { classes: commonClasses } = commonStyles()
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext<ButtonInCreation>()
  const { buttonData } = values
  return (
    <div
      className={clsx(
        classes.sectionWrapper,
        classes.cardHeadingWrapper,
        classes.name
      )}
    >
      <Typography
        className={classes.textHeading}
        data-testid="button-name-description"
      >
        Unique name of the button
      </Typography>
      <TextInputV2
        keyName="buttonData.name"
        title="Enter name"
        type="text"
        placeHolder=""
        updatedValue={buttonData?.name as string}
        value={buttonData?.name as string}
        isError={!!(touched?.buttonData?.name && errors?.buttonData?.name)}
        onChange={handleChange}
        isReadOnly={false}
        isRequired={false}
        errorText={
          (!!touched?.buttonData?.name && errors?.buttonData?.name) || ''
        }
        showSpinner={false}
        onBlur={handleBlur}
      />
    </div>
  )
}
